import React from 'react';
import { useAuth } from '@client/lib/auth';
import UserPickerSelect from './UserPickerSelect';
import styles from './UsersBar.module.css';

type Props = {
	fixedBy?: number | null;
	operatedBy?: number | null;
	onChangeFixedBy?: (v: number | undefined) => void;
	onChangeOperatedBy?: (v: number | undefined) => void;
	extra?: React.ReactNode;
};

const UsersBar = ({
	fixedBy,
	operatedBy,
	onChangeFixedBy,
	onChangeOperatedBy,
	extra,
}: Props) => {
	const { userOptions } = useAuth();

	return (
		<div className={styles.userBar}>
			<div className={styles.item}>
				<span className={styles.label}>Fixed by</span>
				<UserPickerSelect
					value={fixedBy ?? undefined}
					options={userOptions}
					onChange={onChangeFixedBy ?? (() => {})}
				/>
			</div>
			<div className={styles.item}>
				<span className={styles.label}>Operated by</span>
				<UserPickerSelect
					value={operatedBy ?? undefined}
					options={userOptions}
					onChange={onChangeOperatedBy ?? (() => {})}
				/>
			</div>
			{extra ? (<div className={styles.extra}>{extra}</div>) : null}
		</div>
	);
};

export default UsersBar;
